document.addEventListener('DOMContentLoaded', function() {
  const fbtSection = document.querySelector('.anvibha-frequently-bought');
  if (!fbtSection) return;

  const checkboxes = fbtSection.querySelectorAll('.anvibha-fbt-checkbox:not([disabled])');
  const totalPriceEl = fbtSection.querySelector('[data-total-price]');
  const addToCartBtn = fbtSection.querySelector('[data-fbt-add-to-cart]');
  
  // Get main product price
  const mainProductCheckbox = fbtSection.querySelector('.anvibha-fbt-checkbox[disabled]');
  let totalPrice = parseInt(mainProductCheckbox.getAttribute('data-price'));

  function updateTotal() {
    let newTotal = parseInt(mainProductCheckbox.getAttribute('data-price'));
    
    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        newTotal += parseInt(checkbox.getAttribute('data-price'));
      }
    });
    
    totalPrice = newTotal;
    
    // Format price (assuming Shopify money format)
    const formattedPrice = (newTotal / 100).toFixed(2);
    totalPriceEl.textContent = Shopify.formatMoney(newTotal, totalPriceEl.textContent);
  }

  // Listen to checkbox changes
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', updateTotal);
  });

  // Add to cart functionality
  addToCartBtn.addEventListener('click', async function() {
    const selectedVariants = [];
    
    // Add main product
    selectedVariants.push({
      id: mainProductCheckbox.getAttribute('data-variant-id'),
      quantity: 1
    });

    // Add selected related products
    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        selectedVariants.push({
          id: checkbox.getAttribute('data-variant-id'),
          quantity: 1
        });
      }
    });

    // Add items to cart
    try {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: selectedVariants
        })
      });

      if (response.ok) {
        const data = await response.json();
        addToCartBtn.textContent = 'Added! ✓';
        
        // Calculate total quantity added
        const totalQuantityAdded = selectedVariants.reduce((sum, item) => sum + item.quantity, 0);
        
        // Dispatch cart update event with quantity added
        const cartUpdateEvent = new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: data,
            sourceId: 'anvibha-frequently-bought',
            data: {
              itemCount: totalQuantityAdded,
              source: 'product-form-component'
            }
          }
        });
        document.dispatchEvent(cartUpdateEvent);
        
        // Reset button after 2 seconds
        setTimeout(() => {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add Selected to Cart';
        }, 2000);
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Error - Try Again';
      
      setTimeout(() => {
        addToCartBtn.textContent = 'Add Selected to Cart';
      }, 2000);
    }
  });

  // Initial total calculation
  updateTotal();
});
